import { Howl } from "howler";

const path = "/wp-content/themes/kopiraittilankoulu/assets/global/sounds/";
const sounds = {
    right: new Howl({ src: [path + "answer_right.mp3"] }),
    wrong: new Howl({ src: [path + "answer_wrong.mp3"] }),
    fail: new Howl({ src: [path + "fail.mp3"] }),
    tip: new Howl({ src: [path + "tip.mp3"] }),
    clock: new Howl({ src: [path + "clock.mp3"] }),
    plus: new Howl({ src: [path + "achieved.mp3"] }),
    found: new Howl({ src: [path + "found.mp3"] }),
    nomatch: new Howl({ src: [path + "bump.mp3"] }),
    kapseli: new Howl({ src: [path + "aikakapseli.mp3"] }),
    door_open: new Howl({ src: [path + "door_open.mp3"] }),
    buzzer: new Howl({ src: [path + "buzzer.mp3"] }),
    rocket: new Howl({ src: [path + "rocket.mp3"] }),
    hiphop: new Howl({ src: [path + "hiphop.mp3"] }),
    popup: new Howl({ src: [path + "popup.mp3"] }),
    camera: new Howl({ src: [path + "camera.mp3"] }),
    arcade: new Howl({ src: [path + "arcade.mp3"] }),
    racoon: new Howl({ src: [path + "racoon.mp3"] }),
    pot: new Howl({ src: [path + "pot.mp3"] }),
    guitar: new Howl({ src: [path + "kitara.mp3"] }),
    bongo: new Howl({ src: [path + "bongo.mp3"] }),
    paper: new Howl({ src: [path + "paper.mp3"] }),
    radio: new Howl({ src: [path + "radio.mp3"] }),
    horn: new Howl({ src: [path + "mountainhorn.mp3"] }),
    laugh: new Howl({ src: [path + "toylaugh.mp3"] }),
    magic: new Howl({ src: [path + "magic.mp3"] }),
    dvd: new Howl({ src: [path + "dvd.mp3"] }),
    viulu: new Howl({ src: [path + "viulu.mp3"] }),
    mikro: new Howl({ src: [path + "microwave.mp3"] }),
    kahvi: new Howl({ src: [path + "coffeemaker.mp3"] }),
    spin: new Howl({ src: [path + "spin.mp3"] }),
};

window.soundEffect = function (effectName) {
    if (sounds[effectName]) {
        sounds[effectName].play();
    } else {
        console.debug("Sound effect not found: " + effectName);
    }
};

window.playAudioFile = function (fileURL) {
    Howler.stop();
    const sound = new Howl({ src: [fileURL] });
    sound.play();
};
